<template>
  <div>
    <form
      class="form"
      novalidate>
      <div class="custom-field phone-wrapper" v-if="isEditMode">

        <!-- Country code select -->
        <OneSelect
          :brandClass="brandClass()"
          :t="$t"
          :selectId="selectId"
          class="phone-countrycode-select"
          :profileStyle="true"
          v-model="form.countryCode"
          :form="v$.form"
          :paramName="'countryCode'"
          :disabled="isInputDisabled || options.length === 0"
          :options="options"
          @update:modelValue="updateValue()"
          @blur="
            touchForm('countryCode');
            touchForm('phone');
          "
          :isSearchEnabled="true"
          :errors="[
                      // {
                      //   message : $t('profile_personal_data_phone_error_required'),
                      //   thereIsTheError : v$.form.phone.required.$invalid
                      // },
                      {
                        message : $t('profile_personal_data_phone_error_valid'),
                        thereIsTheError : v$.form.phone.phone.$invalid
                      },
                    ]"
        />

        <!-- Phone number input -->
        <OneInput
          :id="communicationPhone.consGUID || `phone-${communicationPhone.communicationStatus}-${communicationPhone.communicationType}`"
          :brandClass="brandClass()"
          :label="'!'"
          class="phone-input"
          :profileStyle="true"
          v-model.trim="form.phone"
          :placeholder="$t('profile_enter_phone_number')"
          :form="v$.form"
          :inputmode="'numeric'"
          :paramName="'phone'"
          :disabled="isInputDisabled"
          @update:modelValue="updateValue()"
          @blur="
            touchForm('countryCode');
            touchForm('phone');
          "
          :hideErrors='true'
          :errors="[
                      // {
                      //   message : '!',
                      //   thereIsTheError : v$.form.phone.required.$invalid
                      // },
                      {
                        message : '!',
                        thereIsTheError : v$.form.phone.phone.$invalid
                      },
                    ]"
        />

        <!-- Delete button -->
        <div class="infos">
          <div class="info">
            <div
              @keydown="ariaClick"
              role="button"
              :tabindex="isEditDeleteButtonDisabled ? '-1' : '0'"
              :aria-label="$t('profile_delete_button')"
              class="delete additional-hitbox"
              :class="{
                        'pointer': !isEditDeleteButtonDisabled,
                        'hidden': disabled,
                        'disabled': isEditDeleteButtonDisabled,
                      }"
              @click="isEditDeleteButtonDisabled ? undefined : emitDelete()"
              :disabled="isEditDeleteButtonDisabled ? true : undefined"
            />
          </div>
        </div>
      </div>
      <div
        v-else-if="communicationPhone.value"
        class="info-container with-radio"
      >

        <!-- Preferred radio -->
        <div
          @keydown="ariaClick"
          role="button"
          tabindex="0"
          @click="emitPreferred()"
          class="radio"
          :aria-label="$t('preferred')"
          :class="{
                    'pointer': true,
                    'selected': communicationPhone.preferred
                  }"
        />

        <!-- Phone number -->
        <div class="value phone-value">
          {{ communicationPhone.value }} {{ communicationPhone.preferred ? '(' + $t('preferred') + ')' : '' }}
        </div>

        <!-- Delete button -->
        <div class="infos">
          <div class="info">
            <div
              @keydown="ariaClick"
              role="button"
              tabindex="0"
              :aria-label="$t('profile_delete_button')"
              class="delete additional-hitbox"
              :class="{
                        'pointer': true,
                        'hidden': disabled
                      }"
              @click="emitDelete()"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.phone-wrapper {
  .phone-input {
    width: calc(100% - 180px) !important;
  }

  .infos {
    height: 100%;
    display: inline-block !important;
    padding: 0 !important;
    padding-left: 1rem !important;

    .info {
      height: 100%;
      position: static !important;
      display: inline-flex;
      align-items: center;
      margin-bottom: 0 !important;

      .delete {
        // position: static !important;
        top: 3px !important;
        right: -15px !important;
        width: 44px !important;
        height: 44px !important;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 12px 20px;

        &.disabled {
          outline-offset: 0 !important;

          &:hover {
            outline: none !important;
          }
        }
      }
    }
  }
}
</style>

<script>
import useVuelidate from '@vuelidate/core'
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

import {
  required
} from "@vuelidate/validators";

export default {
  inject:['$c', '$t', 'brandClass'],
  emits: ['update:modelValue','onPreferredChange', 'onDelete'],
  setup() {
    return { v$: useVuelidate() }
  },
  name: "OnePhoneNumber",
  //validations from vuelidate
  mixins: [oneUtils.customValidationMixin, oneUtils.accessibilityMixin],
  props: {
    user: {},
    disabled: {
      default: false,
      type: Boolean,
    },
    communicationPhone: {},
    preferred: {
      default: false,
      type: Boolean,
    },
    modelValue:{
      type: String,
    },
    isEditMode: {
      default: false,
      type: Boolean,
    },
    isInputDisabled: {
      dafalut: false,
      type: Boolean
    },
    selectId: {
      default: null,
      type: String
    }
  },
  data: () => ({
    form: {
      phone: null,
      countryCode: null,
      preferred: null,
    },
    phoneUtil: null,
    optionstemp: [],
    options:[]
  }),
  //vuelidate custom validations
  validations: {
    form: {
      countryCode:{},
      phone: {
        phone: function (value) {
          if (value && value !== '') {
            let numberProto = null;
            try {
              numberProto = this.phoneUtil.parse(this.v$.form.countryCode.$model.split('-')[1]+value);
              return this.phoneUtil.isValidNumber(numberProto);
            } catch (e) {
              return false;
            }
          } else {
            return true;
          }
        },
      },
    }
  },
  computed: {
    isButtonDisabled: function () {
      return this.v$.$invalid;
    },
    isEditDeleteButtonDisabled() {
      return this.form.phone ? false : true;
    }
  },
  async mounted(){
    // Import google phone library
    this.phoneUtil = await(await import('google-libphonenumber')).PhoneNumberUtil.getInstance();
    this.PNF = await(await import('google-libphonenumber')).PhoneNumberFormat;
    this.getSelectOptionsCountryCode();
    // this.checkPreferredIndex();
    // this.initForm();
    this.prefillForm();
  },
  methods: {
    updateValue() {
      //validate values
      this.touchForm('countryCode');
      this.touchForm('phone');

      // EMIT ONLY IF VALID
      // if (this.v$.$invalid) {
      //   this.$emit("update:modelValue", null);
      // } else {
      //   const value = this.phoneUtil.format(this.phoneUtil.parse(this.form.countryCode.split('-')[1]+this.form.phone), this.PNF.INTERNATIONAL);
      //   this.$emit("update:modelValue", value);
      // }

      // EMIT ANYWAY
      try {
        const value = this.phoneUtil.format(this.phoneUtil.parse(this.form.countryCode.split('-')[1]+this.form.phone), this.PNF.INTERNATIONAL);
        // const value = this.phoneUtil.parse(this.form.countryCode.split('-')[1]+this.form.phone);
        this.$emit("update:modelValue", value);
      } catch (e) {
        this.$emit("update:modelValue", null);
      }
    },
    /**
     * Return object with country and country code
     */
    getSelectOptionsCountryCode(){
      const countries=this.phoneUtil.getSupportedRegions();
      // const countries = this.$c("list_of_countries");
      for (const country of countries) {
        if(country!="KZ"){
          const option = {
            label: country+" (+"+this.phoneUtil.getCountryCodeForRegion(country)+")",
            value: country+"-+"+this.phoneUtil.getCountryCodeForRegion(country),
          };
          this.options.push(option);
          this.optionstemp.push(
            {
              country: country,
              code: this.phoneUtil.getCountryCodeForRegion(country)
            }
          );
        }
      }
    },
    /**
     * Form valorization
     */
    prefillForm: function () {
      if (this.modelValue) {
        const phone = this.phoneUtil.parse(this.modelValue.replace(/\s/g, ''));
        this.form.phone = phone.getNationalNumber();
        this.touchForm("phone");

        const opt = this.optionstemp.find((o)=>o.code === phone.getCountryCode());
        this.form.countryCode = opt.country + '-+' + phone.getCountryCode();
        this.touchForm("countryCode");
      } else {
        this.form.countryCode = this.phoneUtil.getCountryCodeForRegion(this.$store.state.configurationParams.country)!=0 ? this.$store.state.configurationParams.country+'-+'+this.phoneUtil.getCountryCodeForRegion(this.$store.state.configurationParams.country): '+';
      }

      this.form.preferred = !!this.preferred;
    },
    emitPreferred() {
      this.$emit('onPreferredChange', this.communicationPhone)
    },
    emitDelete() {
      this.$emit('onDelete', this.communicationPhone)
    }
  },
};
</script>
